export default __webpack_public_path__ + "static/media/PadlockClose.efb410b6.svg";